import { createStore, applyMiddleware, } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { getLanguageId } from './utils/globals';
import getReducer from './reducers';
import { Actions as PageActions } from './actions/page';
import { Actions as DataActions } from './actions/data';
import rootSaga from './sagas';
import { addBreadCrumb } from './utils/bugTracking';
export let store;
// This is for Sentry
const breadcrumbLogger = () => {
    return (next) => (action) => {
        addBreadCrumb({
            message: `createAction:${action.type}`,
            data: action,
        });
        return next(action);
    };
};
const sagaMiddleware = createSagaMiddleware();
export function setupInitialState(reducer, initialPageData, path) {
    if (!initialPageData || !path)
        return undefined;
    let state = undefined;
    if (initialPageData.error) {
        state = errorInitialState(reducer, state, path, initialPageData);
    }
    if (initialPageData.categoryTree) {
        state = categoryTreeInitialState(reducer, state, initialPageData.categoryTree);
    }
    if (initialPageData.page) {
        const page = initialPageData.page;
        if (page.pageType === 'article') {
            state = articlePageInitialState(reducer, state, page.articleId, page.data);
        }
        else if (page.pageType === 'category') {
            state = categoryPageInitialState(reducer, state, page.categoryId, page.data);
        }
    }
    return state;
}
function errorInitialState(reducer, state, path, initialData) {
    var _a, _b, _c;
    if (!initialData.error)
        return state;
    let errorPayload;
    if (initialData.page) {
        if (initialData.page.pageType === 'article') {
            errorPayload = {
                pageType: 'article',
                articleId: initialData.page.articleId,
                path,
                errorStatus: (((_a = initialData.error.extensions) === null || _a === void 0 ? void 0 : _a.code) ||
                    'HasError'),
                errors: [initialData === null || initialData === void 0 ? void 0 : initialData.error] || [],
            };
        }
        else if (initialData.page.pageType === 'category') {
            errorPayload = {
                pageType: 'category',
                categoryId: initialData.page.categoryId,
                path,
                errorStatus: (((_b = initialData.error.extensions) === null || _b === void 0 ? void 0 : _b.code) ||
                    'HasError'),
                errors: [initialData === null || initialData === void 0 ? void 0 : initialData.error] || [],
            };
        }
    }
    if (!errorPayload) {
        errorPayload = {
            pageType: 'error',
            path,
            errorStatus: (((_c = initialData.error.extensions) === null || _c === void 0 ? void 0 : _c.code) ||
                'HasError'),
            errors: [initialData === null || initialData === void 0 ? void 0 : initialData.error] || [],
        };
    }
    const action = PageActions.pageNavError(errorPayload);
    return reducer(state, action);
}
function categoryTreeInitialState(reducer, state, data) {
    const languageId = getLanguageId();
    const now = Date.now();
    const action = DataActions.categoryTreeHydrate({ data, now, languageId });
    return reducer(state, action);
}
function articlePageInitialState(reducer, state, articleId, data) {
    const languageId = getLanguageId();
    const now = Date.now();
    const action = DataActions.articlePageDataHydrate({
        data,
        now,
        articleId,
        languageId,
    });
    return reducer(state, action);
}
function categoryPageInitialState(reducer, state, categoryId, data) {
    const languageId = getLanguageId();
    const now = Date.now();
    const action = DataActions.categoryPageDataHydrate({
        data,
        now,
        categoryId,
        languageId,
    });
    return reducer(state, action);
}
export function setupStore({ initialPageData, path, config, }) {
    const reducer = getReducer(config);
    const initialState = setupInitialState(reducer, initialPageData, path);
    const _store = createStore(reducer, initialState, composeWithDevTools({ trace: process.env.NODE_ENV !== 'production' })(applyMiddleware(sagaMiddleware, breadcrumbLogger)));
    // fire up redux saga
    sagaMiddleware.run(rootSaga);
    return _store;
}
//# sourceMappingURL=reduxStore.js.map